import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { InProductHelpButtonProps } from '../src/Buttons/InProductHelpButton.tsx';

export const InProductHelpButton: LoadableType<InProductHelpButtonProps> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ButtonsInProductHelpButton" */ '../src/Buttons/InProductHelpButton.tsx'
			)
		).InProductHelpButton,
});
